import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PcsMerchantSchema = withDefaults({
  type: 'pcs-merchant',
  fields: [
    {
      kind: 'attribute',
      name: 'entityType',
    },
    {
      kind: 'attribute',
      name: 'entityId',
    },
    {
      kind: 'attribute',
      name: 'locationNames',
    },
    {
      kind: 'hasMany',
      name: 'pcsMerchantNetworkMerchants',
      type: 'pcs-merchant-network-merchant',
      options: {
        async: false,
        inverse: 'pcsMerchant',
      },
    },
    {
      kind: 'hasMany',
      name: 'pcsNetworkMerchants',
      type: 'pcs-network-merchant',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default PcsMerchantSchema;
